

<!-- breadcrumbs
<app-breadcrumbs
  [crumbs]="crumbs$ | async"
  *ngIf="showCrumbs">
</app-breadcrumbs>
 -->

<app-product-page
    [product]="product$ | async">
</app-product-page>